import { put } from 'redux-saga/effects';

import {
    fetchWinlosesSuccess
} from './actions';

import { winLosesURL } from '../../api';

export function* fetchWinlosesAsync(date) {
    try {
        const response = yield fetch(`${winLosesURL}/${date}`, {
            method: "GET"
        })
        const json = yield response.json()
        yield put(fetchWinlosesSuccess(json))
    } catch (error) {
        console.log(error.message)
    }
}